export default function numberFormatterBack(n: string) {
  return n.replace(/\$\s?|(,*)/g, '');
}
